import gql from 'graphql-tag';

const DriverFeedback = gql(/* GraphQL */ `
  mutation DriverFeedback($input: DriverFeedbackInput!) {
    driverFeedback(input: $input) {
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default DriverFeedback;
